import { useEffect } from "react";

export const useEscape = (onClose) => {
  useEffect(() => {
    const h = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [onClose]);
};

export const paragraphs = (text) => (text || "")
  .replace(/\s*([•▪●])\s*/g, "\n$1 ")
  .replace(/\s+(\d{1,2}\.)\s+(?=[A-Z])/g, "\n$1 ")
  .split(/\n+|(?<=[.!?])\s+(?=[A-Z][a-z]+\s[a-z])/)
  .reduce((acc, s, i, arr) => {
    const t = s.trim();
    if (!t) return acc;
    const isList = /^([•▪●]|\d{1,2}\.)\s/.test(t);
    const last = acc[acc.length - 1];
    if (!isList && last && !last.list && last.n < 3) { last.text += ` ${t}`; last.n += 1; } else acc.push({ text: t, n: 1, list: isList });
    return acc;
  }, []);
